import { useState, useEffect } from "react";
import { AutoComplete, Empty, Tooltip } from "antd";
import removeMarkdown from "remove-markdown";
import { useWordingTemplates } from "~/hooks/useWordingTemplates";
import RichContent from "~/components/app/RichContent";
import WordingTemplateNotfound from "~/components/app/WordingTemplateNotfound";

const WordingTemplateAutoComplete = ({
  scenario,
  onChange,
  onSelectTemplate,
  placeholder,
}) => {
  const { wordingTemplates, loading, setKeyword } = useWordingTemplates({
    scenario,
  });
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  // 解决下拉框滚动时整体位置变动的问题
  useEffect(() => {
    const handleWheel = (e) => {
      // 查找当前显示的下拉框
      const dropdown = document.querySelector(
        ".ant-select-dropdown:not(.ant-select-dropdown-hidden)"
      );

      if (dropdown && dropdown.contains(e.target)) {
        // 当鼠标在下拉框内时，阻止页面滚动
        e.preventDefault();
      }
    };

    // 使用 passive: false 确保可以调用 preventDefault
    document.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);

  const options = wordingTemplates.map((template, index) => {
    // 使用 raw 内容（markdown 格式），显示时需要转换为 HTML 格式渲染
    const content = template.content_raw;
    return {
      id: template.id,
      key: template.id,
      value: content,
      label: (
        <Tooltip
          placement="right"
          title={<RichContent html={template.content} />}
          overlayClassName="wording-template-tooltip"
          key={template.id}
        >
          <div
            style={{
              borderTop: index > 0 ? "1px solid #e8e8e8" : "none",
              paddingTop: index > 0 ? "10px" : "0",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              cursor:
                selectedTemplate?.id === template.id ? "pointer" : "default",
            }}
          >
            <span style={{}}>{template.title}</span>
          </div>
        </Tooltip>
      ),
    };
  });

  const handleSearch = (value) => {
    setKeyword(value);
  };

  const handleClear = () => {
    setKeyword("");
  };

  const handleChange = (value) => {
    setKeyword(value);
    onChange(value);
  };

  const handleSelect = (value, option) => {
    setSelectedTemplate(option);
    onSelectTemplate(option);
    setKeyword("");
  };

  return (
    <AutoComplete
      style={{ width: "100%" }}
      loading={loading}
      placeholder={placeholder || "搜索模板"}
      options={options}
      allowClear
      onChange={handleChange}
      onSearch={handleSearch}
      onClear={handleClear}
      onSelect={handleSelect}
      notFoundContent={!loading && <WordingTemplateNotfound />}
    />
  );
};

export default WordingTemplateAutoComplete;
